import { StoreMinimalModel } from "./Store";
import {
  Priority,
  Product,
  ProductId,
  ProductMinimalModel,
  ProductSpoilageReason
} from "./Product";
import { OrderUnit } from "./Order";

export type StoreInventoryItemId = string;

export interface MinimalStoreInventoryItem {
  id: StoreInventoryItemId;
  productId: string;
  gtin: string;
  productName: string;
  brandName: string;
  storeId: string;
  storeName: string;

  onShelf: number;
  onShelfWorth: number;
  inStorage: number;
  hasPriceTag: boolean;
  isOrderable: boolean;

  // overrides
  maxOnShelf?: number;
  orderThreshold?: number;
  orderUnit?: OrderUnit;
  price?: number;
  acquisitionPrice?: number;
  articleNumber?: string;
  priority?: Priority;

  created: Date;
  updated: Date;

  exists: boolean; // helper
}

export interface StoreInventoryItem {
  id: StoreInventoryItemId;
  productId: string;
  gtin: string;
  productName: string;
  brandName: string;
  product: Product;
  storeId: string;
  storeName: string;

  onShelf: number;
  onShelfWorth: number;
  inStorage: number;
  hasPriceTag: boolean;
  isOrderable: boolean;
  quantitySold?: number;

  // overrides
  maxOnShelf?: number;
  orderThreshold?: number;
  orderUnit?: OrderUnit;
  price?: number;
  acquisitionPrice?: number;
  articleNumber?: string;
  priority?: Priority;

  created: Date;
  updated: Date;

  exists: boolean; // helper

  reportedProductSpoilage?: ProductSpoilageReport[];
  reportedStocktaking?: ReportedStocktaking[];
  reportedProductDelivery?: ReportedProductDelivery[];
}

export interface StoreInventoryItemWriteModel {
  productId: ProductId;
  onShelf: number;
  inStorage: number;
  hasPriceTag: boolean;
  isOrderable: boolean;

  // overrides
  maxOnShelf?: number;
  orderThreshold?: number;
  orderUnit?: OrderUnit;
  price?: number;
  articleNumber?: string;
  priorityId?: number;
}

export interface ProductSpoilageReport {
  id?: string;
  quantity: number;
  comment: string;
  date?: string;
  reportedBy?: string;
  reasonId?: number;
  reasonName?: string;
  storeStocktakingId?: string;
}

export interface ReportedStocktaking {
  id: string;
  created: Date;
  updated: Date;
  reportedBy: string;
  productName: string;
  brandName: string;
  onShelf: number;
  onShelfBefore: number;
}

export interface ReportedProductDelivery {
  id: string;
  created: Date;
  reportedBy: string;
  onShelfQuantity: number;
  onShelfQuantityBeforeDelivery: number;
  storeStocktakingId?: string;
}

export const toMinimalStoreInventoryItem = (
  from: StoreInventoryItem
): MinimalStoreInventoryItem => ({
  ...from,
  productId: from.productId ?? from.id
});

export const toStoreInventoryItem = (
  from: MinimalStoreInventoryItem,
  product: Product
): StoreInventoryItem => ({
  ...from,
  product: {
    ...product
  }
});
